import React from 'react'
import { Link } from 'react-router-dom'
import styled from 'styled-components'
import { colors, layout, bp } from '../../../theme'

const Main = styled.section`
  padding: ${layout.section};
`

const Container = styled.div`
  max-width: ${layout.maxWidth};
  margin: auto;
  background: ${colors.greenLight};
  border: 1px solid ${colors.line};
  border-radius: ${layout.radius};
  padding: 2.75rem;
  display: grid;
  grid-template-columns: 1.1fr 0.9fr;
  gap: 2rem;
  align-items: center;

  @media (max-width: ${bp.tablet}) {
    grid-template-columns: 1fr;
    padding: 2rem 1.5rem;
  }
`

const Copy = styled.div`
  .kicker {
    color: ${colors.green};
    font-weight: 800;
    font-size: 0.82rem;
    letter-spacing: 1px;
    text-transform: uppercase;
    margin-bottom: 0.5rem;
  }

  h2 {
    margin: 0 0 0.6rem;
    font-size: 2rem;
    color: ${colors.ink};
    line-height: 1.15;

    @media (max-width: ${bp.mobile}) {
      font-size: 1.6rem;
    }
  }

  p {
    margin: 0 0 1.5rem;
    color: ${colors.slate};
    line-height: 1.65;
  }
`

const Actions = styled.div`
  display: flex;
  gap: 0.8rem;
  flex-wrap: wrap;
`

const Primary = styled.a`
  text-decoration: none;
  background: ${colors.green};
  color: ${colors.white};
  font-weight: 700;
  padding: 0.85rem 1.4rem;
  border-radius: 10px;
  transition: 0.2s ease;

  &:hover {
    background: ${colors.greenDark};
  }
`

const Ghost = styled(Link)`
  text-decoration: none;
  background: ${colors.white};
  color: ${colors.ink};
  border: 1.5px solid ${colors.line};
  font-weight: 700;
  padding: 0.85rem 1.4rem;
  border-radius: 10px;
  transition: 0.2s ease;

  &:hover {
    border-color: ${colors.green};
    color: ${colors.green};
  }
`

const Details = styled.div`
  background: ${colors.white};
  border: 1px solid ${colors.line};
  border-radius: ${layout.radius};
  padding: 1.5rem 1.75rem;
`

const Row = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0.7rem 0;
  border-bottom: 1px solid ${colors.line};

  &:last-child {
    border-bottom: none;
  }

  .k {
    font-size: 0.75rem;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    color: ${colors.green};
    font-weight: 800;
    margin-bottom: 0.2rem;
  }

  .v {
    color: ${colors.ink};
    font-size: 0.96rem;
    line-height: 1.5;
  }

  a {
    color: ${colors.ink};
    text-decoration: none;
  }
  a:hover {
    color: ${colors.green};
  }
`

const Contact = () => (
  <Main id="contact">
    <Container>
      <Copy>
        <div className="kicker">Get in touch</div>
        <h2>Partner with Despar Clean</h2>
        <p>
          Talk to us about bulk supply, B2B contracts, or installing an NBIoT EcoSmart
          Dispenser at your site. Operators can sign in to the management dashboard to
          monitor dispensers and payments in real time.
        </p>
        <Actions>
          <Primary href="mailto:info@desparclean.com">Email Our Team</Primary>
          <Ghost to="/login">Dashboard Login</Ghost>
        </Actions>
      </Copy>

      <Details>
        <Row>
          <span className="k">Headquarters</span>
          <span className="v">KSD Business Park, Embakasi, Nairobi, Kenya</span>
        </Row>
        <Row>
          <span className="k">Email</span>
          <span className="v">
            <a href="mailto:info@desparclean.com">info@desparclean.com</a>
          </span>
        </Row>
        <Row>
          <span className="k">Phone</span>
          <span className="v">0723 437 122 · 0729 230 330 · 0733 935 595</span>
        </Row>
        <Row>
          <span className="k">Web</span>
          <span className="v">www.desparclean.com</span>
        </Row>
      </Details>
    </Container>
  </Main>
)

export default Contact
